module.exports = __webpack_public_path__ + "static/media/5.56208d1b.png";